/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";

import { Grid } from "@mui/material";
import axios from "axios";
import MDButton from "components/MDButton";
import ViewCard from "components/ViewCard/ViewCard";
import CustomText from "components/customtext/customtext";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import "./viewDetails.scss";

let fetchedData;
let fOrder;
let LOGIN_DETAILS

function ViewDetailsWarehouse() {
    const { id } = useParams();
    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);
    const [values, setValues] = React.useState({
        orderNumber: "",
        orderDate: "",
        shipmentType: "",
        paymentType: "",
        senderCity: "",
        receiverCity: "",
        distance: "",
        totalCharges: "",
    });

    const [valuesLog, setValuesLog] = React.useState({
        assignedDriverID: "",
        jobStatus: "",
        jobStatusNotes: "",
    });

    const handleChangeLog = (name) => (event) => {
        setValuesLog({ ...valuesLog, [name]: event.target.value });
    };


    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;

    useEffect(() => {
        if (id !== undefined) {
            fetchOrder()
        }

    }, [])

    const fetchOrder = async () => {

        console.log("values", values)
        await axios.post(appConstants.baseURL + 'order/fetchOrderByID', { id: id })
            .then(
                (res) => {
                    let response = res.data;
                    console.log("fetchOrderByID(response)", response)
                    if (response.Result_Output.length > 0) {      
                        setValues(response.Result_Output[0]);
                        setRows(response.Result_Output);
                      }
                    // fetchedData = response.Result_Output[0];
                    // console.log("fetchedData", fetchedData)
                    // const options = { year: 'numeric', month: 'short', day: 'numeric' };
                    // const timeOption = { timeZone: 'UTC', hour12: true, hour: '2-digit', minute: '2-digit', }
                    // fetchedData.orderDate = new Date(response.Result_Output.orderDetail[0].orderDate).toLocaleDateString('en-US', options, timeOption);
                    // setValues(fetchedData)
                    // setRows(response.Result_Output)
                }
               
            )
            .catch(

                (error) => { console.log("Error in fetchOrderByID=" + JSON.stringify(error)) }
            );

    }

    const screenName = "Order Information"
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Height val={30} />
            <Card >
                <PageTitle screenName={screenName} />
                <Grid container px={2}>
                    <Grid item xs={12} md={3} lg={12} sx={{ display: "flex", justifyContent: "end" }}>
                        <Link to={"/warehouseDashboard"} >
                            <MDButton color="warning">Back</MDButton>
                        </Link>
                    </Grid>
                </Grid>
                <Grid container px={2} mt={4} columnSpacing={2} justifyContent={"space-between"}>
                    <Grid item xs={4.5}>
                        <Card sx={darkMode ?{ backgroundColor: "#202940" }: { backgroundColor: "aliceblue" }}>
                            <Grid container>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pt={2}
                                >
                                    <CustomText type="p" size={17} >
                                        Order Number:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5}
                                    pt={2}>
                                    <CustomText type="b" size={16} >
                                        {values.orderNumber}
                                    </CustomText>
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pb={2}
                                >
                                    <CustomText type="p" size={17} >
                                        Order Date:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pb={2}>
                                    <CustomText type="b" size={16} >
                                        {values.orderDate}
                                    </CustomText>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    
                    <Grid item xs={4.5}>
                        <Card sx={darkMode ?{ backgroundColor: "#202940" }: { backgroundColor: "aliceblue" }}>
                            <Grid container>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pt={2}
                                >
                                    <CustomText type="p" size={17} >
                                        Consignment Type:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5}
                                    pt={2}>
                                    <CustomText type="b" size={16} >{values.shipmentType} </CustomText>
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                    style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                                    pl={5}
                                    pb={2}
                                >
                                    <CustomText type="p" size={17} >
                                        Payment Type:
                                    </CustomText>
                                </Grid>
                                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5}
                                    pb={2}>
                                    <CustomText type="b" size={16} >{values.paymentType}</CustomText>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>

                <Grid container px={2} mt={4} columnSpacing={2} justifyContent={"space-between"}>
                    <Grid item xs={4.5} pl={5}>
                        <Card sx={darkMode ?{ backgroundColor: "#202940" }: { backgroundColor: "aliceblue" }}>
                            <Grid item xs={8} pl={5} style={{ display: "flex", alignItems: "center" }} pt={3}>
                                <CustomText type="p" size={17}   >
                                    Sender Address:
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >
                                    {values.senderName}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >
                                    {values.senderStreetAddress}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >
                                    {values.senderCity} , {values.senderZipCode}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >

                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >

                                    {values.senderContactNumber}
                                </CustomText>
                            </Grid>

                            <Height val={28} />
                        </Card>
                    </Grid>
                    <Grid item xs={3}>
            <ViewCard sx={darkMode ?{ backgroundColor: "#202940" }: { backgroundColor: "aliceblue" }}>
              <Grid container>
                <Grid
                  item
                  xs={8}
                  style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                  pl={5}
                  pt={2}
                >
                  <CustomText type="p" size={17} >
                    Total Charges:
                  </CustomText>
                </Grid>
                <Grid item xs={4} style={{ marginBottom: "2px" }} pl={3}
                  pt={2}>
                  <CustomText type="b" size={16} >{values.totalCharges}</CustomText>
                </Grid>
      
                
                <Grid
                item
                xs={8}
                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                pl={5}
             
              >
                <CustomText type="p" size={17} >
                  Linehaul Charges:
                </CustomText>
              </Grid>
              <Grid item xs={4} style={{ marginBottom: "2px" }} pl={3}
                >
                <CustomText type="b" size={16} >{values.variableCharges}</CustomText>
              </Grid>
              {values.shipmentType === "Sender Location Pickup" &&
                <>
                <Grid
                  item
                  xs={8}
                  style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                  pl={5}
                  pb={2}
                >
                  <CustomText type="p" size={17} >
                    Pickup Charges:
                  </CustomText>
                </Grid>
                <Grid item xs={4} style={{ marginBottom: "2px" }} pl={3}
                  pb={2}>
                  <CustomText type="b" size={16} >{values.fixedCharges}</CustomText>
                </Grid>
                </>
              }
              </Grid>
            </ViewCard>
          </Grid>
                    <Grid item xs={4.5}>
                        <Card sx={darkMode ?{ backgroundColor: "#202940" }: { backgroundColor: "aliceblue" }}>
                            <Grid
                                item
                                xs={8}
                                pl={5}
                                pt={3}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="p" size={17} >
                                    Receiver Address:
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >
                                    {values.receiverName}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >
                                    {values.receiverStreetAddress}<br /> {values.receiverCity} , {values.receiverZipCode}
                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >

                                </CustomText>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                pl={5}
                                style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
                            >
                                <CustomText type="b" size={17} >
                                    {values.receiverContactNumber}
                                </CustomText>
                            </Grid>
                            <Height val={28} />
                        </Card>
                    </Grid>

                </Grid>

                <MDBox px={2} >
                    <DataTable
                        Header={false}
                        screenName={false}
                        addNew={false}
                        //   link="/addDocument"
                        table={{
                            filterable: true,
                            rows,
                            columns: [
                                {
                                    Header: "No Of Items",
                                    accessor: "numberOfItems",
                                    align: "center",
                                },
                                {
                                    Header: "Cargo Type",
                                    accessor: "cargoType",
                                    align: "center",
                                },
                                {
                                    Header: "Description",
                                    accessor: "description",
                                    align: "left",
                                },
                                {
                                    Header: "Weight (Kg)",
                                    accessor: "weightInKg",
                                    align: "center",
                                },
                                {
                                    Header: "Length (mm)",
                                    accessor: "lengthInMm",
                                    align: "center",
                                },

                                {
                                    Header: "Width (mm)",
                                    accessor: "breadthInMm",
                                    align: "center",
                                },
                               
                                
                                {
                                    Header: "Height (mm)",
                                    accessor: "heightInMm",
                                    align: "center",
                                },
                                {
                                    Header: "Linehaul Charges",
                                    accessor: "itemVariableCharge",
                                    align: "center",
                                },

                            ],
                        }}
                        // rows={values.roles}
                        canSearch={false}
                        isSorted={true}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        pagination={true}
                        noEndBorder
                    />
                </MDBox>
            </Card>
        </DashboardLayout >
    );
}

export default ViewDetailsWarehouse;
